import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportOtherReceivingPage } from './report-other-receiving.page';

const routes: Routes = [
  {
    path: '',
    component: ReportOtherReceivingPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportOtherReceivingPageRoutingModule {}
